import React from 'react';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

import Yen from '../../asset/img/yen.svg';
import Pin from '../../asset/img/pin.svg';
import Code from '../../asset/img/code.svg';
import Job from '../../asset/img/job.svg';
import Jyusoku from '../../asset/img/jyusoku.svg';
import Kanryo from '../../asset/img/kanryo.svg';

import {
    Button,
    Divider,
    Grid,
    Typography
} from '@mui/material';

import { withStyles } from '@mui/styles';
import CustomUtil from '../../model/common/CustomUtil';
import Validation from '../../model/common/Validation';
import Message from '../../constants/Message';

// override style
const style = {
    root: {
        margin: '8px',
        position : 'relative',
        '& .agenda-status-icon': {
            position: 'absolute',
            right: '5%',
            bottom : '5%',
            width : '30%'
        },
        '& .main-frame': {
            width : '100%',
            padding: '1.5rem 2rem',
            background: '#FFFFFF 0% 0% no-repeat padding-box',
            border: '1px solid #B1B4E3',
            borderRadius: '30px',
            '& .badge-frame': {
                padding: '1rem 0',
                '& .badge-icon': {
                    fontSize: '0.8rem',
                    border: '1px solid #88888888',
                    padding: '0.2rem 0.5rem',
                    color: '#888888',
                    marginRight: '0.5rem',
                    marginTop: '0.5rem',
                },
                '& .new-arrival': {
                    background: '#006DFF',
                    color: '#FFFFFF',
                    botder : 'none'
                }
            },
            '& .agenda-number-container': {
                '& p' :{
                    fontSize: '0.8rem'
                }
            },
            '& .title-frame': {
                paddingTop: '0.5rem',
                maxHeight: '80px',
                '& .agenda-title':{
                    fontWeight:'bold',
                    fontSize:'1.2rem',
                    whiteSpace:'normal',
                    display:'-webkit-box;',
                    lineClamp:'3',
                    boxOrient:'vertical',
                    overflow:'hidden', 
                }
            },
            '& .icon-frame': {
                marginTop: '0.5rem',
                alignItems: 'center',
                '& .items': {
                    paddingRight: '1rem',
                    width:'calc(100% - 62px)',
                    wordBreak:'keep-all',
                    whiteSpace:'nowrap',
                    overflow:'hidden',
                    textOverflow:'ellipsis'
                },
                '& .icon-container': {
                    alignItems: 'center',
                    marginBottom: '0.5rem',
                    flexWrap : 'nowrap',
                },
                '& .icons': {
                    marginRight: '12px'
                },
                '& .pay': {
                    width : 'auto',
                    paddingRight: '0.4rem',
                    whiteSpace :'nowrap',
                    '&:nth-child(3)': {
                        color: 'red',
                        fontWeight: 'bold',
                        fontSize:'1.4rem'
                    }
                }
            }
        },
        '& .contents-frame': {
            '& th, td': {
                borderTop: '1px solid rgba(224, 224, 224, 1)'
            },
            '& th': {
                background: '#EFEFEF',
            }
        },
        '& .button-frame': {
            '& .btn': {
                border: '1px solid #AAAAAA',
            },
            '& .join': {
                background: '#00BAFF',
                color: '#FFFFFF',
                width: '100%',
                border : 'none;',
                marginTop:'1rem',
            },
            '& .favorites': {
                color: '#888888',
                marginLeft: '2%',
                width: '15%',
                '& .star-added': {
                    color: 'blue',
                }
            }
        },
        '& .bg-gray': {
            background: '#999 !important'
        },
    }
}

class SearchCardSP extends React.Component {
    renderBadgeIcons = (data) => {
        const badges = CustomUtil.getNewArrivalBadgeIcon(data);
        const hitch = CustomUtil.explodeData(',', data.hitch);

        for(const item of hitch){
            badges.push({
                isNewArrival: false, 
                text: item
            })

            if(badges.length > 2){
                break;
            }
        }

        return badges
    }

    renderJoinButton = () => {
        const { joinedAgendaData, data, handleJoinAgenda } = this.props;
        const checkJoined = joinedAgendaData.filter(item => {
            return item === data.idx
        })

        return (
            <>
                { 
                    Validation.empty(checkJoined) ? 
                        <Button className={'btn join'} onClick={() => handleJoinAgenda(data.idx)}>
                            <CheckCircleOutlineIcon />
                            {Message.agendaJoin.beforJoinn}
                        </Button>
                        : 
                        <Button className={'btn join bg-gray'}>
                            {Message.agendaJoin.afterJoin }
                        </Button>
                }
            </>
        )
    }

    renderBottunArea = () => {
        const { data } = this.props;
        if(data.status !== '10'){
            return (<></>)
        }else{
            return (
                <Grid container justifyContent={'center'} className={'button-frame'}>
                    {this.renderJoinButton()}
                    {/* TODO ::: 2차개발 */}
                    {/* <Button className={'btn favorites'}>
                        <StarBorderIcon />{'お気に入り'}
                    </Button> */}
                </Grid>
            )
        }
    }

    render() {
        const { classes, agendaJoinBtn, data, detlPageFnc } = this.props;
        const badges = this.renderBadgeIcons(data);
        const pay = parseInt(data.pay).toLocaleString();

        let stamp = null;
        if(data.status !== '10'){
            stamp = data.status === '20' ? Kanryo : Jyusoku ;
        }

        return (
            <Grid container justifyContent={'center'} classes={classes}>
                <Grid container justifyContent={'center'}>
                    <Grid item className={'main-frame'}>
                        <Grid onClick={()=> detlPageFnc(data.idx)}>
                            { stamp && <img className={'agenda-status-icon'} width={'250'} src={`${stamp}`} alt={''}/> }
                            <Grid container className={'agenda-number-container'}>
                                <Typography>{`案件番号：${data.agenda_number}`}</Typography>
                            </Grid>
                            <Grid className={'title-frame'}>
                                <Typography className="agenda-title">{data.title}</Typography>
                            </Grid>

                            <Grid container justifyContent={'left'} className={'badge-frame'}>
                                {
                                    badges.map((item, key) => {
                                        return <Typography key={key} className={`badge-icon ${item.isNewArrival ? 'new-arrival' : ''}`}>{item.text}</Typography>
                                    })
                                }
                            </Grid>

                            <Divider />

                            <Grid className={'icon-frame'}>
                                <Grid container className={'icon-container'}>
                                    <img src={Yen} alt='' className="icons"/>
                                    <Typography className={'pay'}>{`〜`}</Typography>
                                    <Typography className={'pay'}>{pay}</Typography>
                                    <Typography className={'items pay'}>{`万円/月`}</Typography>
                                </Grid>
                                <Grid container className={'icon-container'}>
                                    <img src={Pin} alt='' className="icons"/>
                                    <Typography className={'items location'}>{data.location}</Typography>
                                </Grid>
                                <Grid container className={'icon-container'}>
                                    <img src={Code} alt='' className="icons"/>
                                    <Typography className={'items req-type'}>{data.language}</Typography>
                                </Grid>
                                <Grid container className={'icon-container'}>
                                    <img src={Job} alt='' className="icons"/>
                                    <Typography className={'items req-type'}>{data.emp_status}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                            
                        { agendaJoinBtn && this.renderBottunArea() }
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

export default withStyles(style)(SearchCardSP);
